import type { TSerializedWidget } from 'src/entities/workspace/types';
import type {
  TWellLogsManagerSerializedInternalState,
  WellLogsManagerWidgetEntity,
} from 'src/pages/dashboard/features/well-logs-manager-widget/WellLogsManagerWidget.entity';

export function serializeWellLogsManagerWidget(widget: WellLogsManagerWidgetEntity): TSerializedWidget {
  const internalState: TWellLogsManagerSerializedInternalState = {
    wellId: widget.wellId,
    stateParams: {
      openLogs: widget.stateParams.openLogs,
      openWellbores: widget.stateParams.openWellbores,
      searchQuery: widget.stateParams.searchQuery,
      selected: widget.stateParams.selected,
      splitContainer: widget.stateParams.splitContainer,
      timeZone: widget.stateParams.timeZone,
    },
  };

  return {
    wellId: widget.wellId,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };
}
